import { z } from 'zod';
import { IInventoryOption } from '../../IInventoryOption';

export const realEstatePurchaseContractInventoryOptionSchema = z.object({
  idRealEstate_has_InventoryOption: z.number().optional(),
  idRealEstatePurchaseContract: z.number().optional(),
  idInventoryOption: z.number(),
  Amount: z.number(),
  Title: z.string().nonempty(),
  Description: z.string().nullable(),
});

export type IRealEstatePurchaseContractInventoryOption = z.infer<
  typeof realEstatePurchaseContractInventoryOptionSchema
>;

export const initPurchaseContractInventoryOption = (
  inventoryOption: IInventoryOption,
  idRealEstatePurchaseContract?: number
): IRealEstatePurchaseContractInventoryOption => ({
  idInventoryOption: inventoryOption.idInventoryOption,
  idRealEstatePurchaseContract,
  Amount: 1,
  Description: null,
  Title: inventoryOption.InventoryOption,
});
